import { useEffect, useState } from "react";
import fetchAPI from "../../../../common/fetchAPI";
import { t } from "i18next";
import { ShowToast } from "../../../../common/Toastr";
import Loader from '../../../../common/Loader';
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { getValueFromResource } from "../../../../common/timeLiveFunction";
import * as Sentry from "@sentry/react";
const EmployeeCostCenter = (props: any) => {
    const { AccountEmployeeId } = props;
    const [costCenterList, setCostCenterList] = useState<any | ''>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isReload, setIsReload] = useState(false);
    const { sessionAccountId} = useAppSelector((state) => state.globalState);
   const dispatch = useAppDispatch();
    useEffect(() => {
        renderEmailNotificationForEmployee();
    }, []);

    useEffect(() => {
        if(isReload){
            renderEmailNotificationForEmployee();
        }
    }, [isReload]);

    const renderEmailNotificationForEmployee = async () => {
        try {
            const response = await fetchAPI(`api/V2/Employees/AccountCostCenterEmployeeByAccountIdandAccountEmployeeId/${sessionAccountId}/${AccountEmployeeId}`, 'Get', '', true);
            const json = await response.json();
            const newArray = json.Data.map((item : any) => ({
                ...item,
                isSelected: 0,
            }));
            setCostCenterList(newArray);
            setIsReload(false);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            Sentry.captureException(error);
        }
    }

    const onHandleChangeStatus = async (e: any, costCenterObject: any) => {
        const { checked } = e.target;
        try {
            costCenterObject.isSelected = checked ? 1 : 0;
            const response = await fetchAPI("api/v2/Employees/UpdateCostCenter/" + AccountEmployeeId, "PUT", costCenterObject, true, "");
            const json = await response.json();
            // const index = costCenterList.findIndex((item: any) => item.AccountCostCenterId === costCenterObject.AccountCostCenterId);
            // const newArray = [...costCenterList];
            // newArray[index].isSelected = checked ? 1 : 0;
            
            if(json.StatusCode === "200")
            {
                setIsReload(true);
                setIsLoading(true);
                ShowToast('Success', "Cost Center Updated Successfully", "success", "toast-top-right")
            }
            else
            {
                setIsReload(false);
                setIsLoading(false);
                ShowToast('Error', "Cost Center Update Failed", "error", "toast-top-right");
            }
            // json[0].StatusCode === "200" && setCostCenterList(newArray); setIsReload(true);
            // json[0].StatusCode === "200" ? ShowToast('Success', "Cost Center Updated Successfully", "success", "toast-top-right") :
            //     ShowToast('Error', "Cost Center Update Failed", "error", "toast-top-right");
        } catch (error) {
            Sentry.captureException(error);
        }
    }

    return (
        <>
            {isLoading ?
                <Loader />
                :
                <div className="card card-custom admin-card">
                    <div className="card-header sticky-top bg-white">
                        <h3 className="card-title fw-bold headerTitle">
                            {/* {t('Cost Center')} */}
                            {getValueFromResource('Cost Center',dispatch, t)}
                            </h3>
                    </div>
                    <div className='card-body py-3'>
                        <div className='table-responsive'>
                            <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                <thead>
                                    <tr className='thHeading align-middle'>
                                        <th className='min-w-300px'>
                                            {/* {t("Cost Center")} */}
                                            {getValueFromResource('Cost Center', dispatch, t)}

                                        </th>
                                        <th className='min-w-50px'>
                                            {/* {t("Active")} */}
                                            {getValueFromResource('Active', dispatch, t)}

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {costCenterList.length > 0 && costCenterList.map((item: any) => {
                                        return (
                                            <tr key={item.AccountEMailNotificationPreferenceId}>
                                                <td className="tdHeight">
                                                    <a className='text-dark d-block'>
                                                        {item.AccountCostCenter}
                                                    </a>
                                                </td>
                                                <td className="tdHeight">
                                                    <div className="form-check form-switch form-check-custom">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                            checked={
                                                                (item.AccountCostCenterEmployeeId !== null && item.AccountCostCenterEmployeeId !== undefined) ? true : false
                                                            }
                                                            onChange={(e) => {
                                                                onHandleChangeStatus(e, item)
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            {costCenterList.length === 0 &&
                                <div className=''>
                                    <p className='noDataFound'>
                                        {/* {t('No Record Found')} */}
                                        {getValueFromResource('No Record Found',dispatch, t)}
                                        </p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default EmployeeCostCenter